import { Direction, Displaying } from "@bonusx-global/bx-design-system";
import styled from "@emotion/styled";

export const ChatbotWrapper = styled("div")({
  display: Displaying.flex,
  flexDirection: Direction.column,
  height: "100%",
});
